const CLAVE_TOKEN = 'token';
const CLAVE_REFRESH = 'refreshToken';

// El backend responde { token, refreshToken, expiresIn }. Se acepta también el
// string plano por compatibilidad con respuestas antiguas.
export const leerTokens = (data) => {
  if (!data) return null;
  if (typeof data === 'string') return { token: data, refreshToken: null };

  const token = data.token ?? data.Token ?? null;
  if (!token) return null;

  return { token, refreshToken: data.refreshToken ?? data.RefreshToken ?? null };
};

// Guarda la sesión y devuelve el access token, o null si la respuesta no traía uno.
export const guardarSesion = (data) => {
  const tokens = leerTokens(data);
  if (!tokens) return null;

  localStorage.setItem(CLAVE_TOKEN, tokens.token);
  if (tokens.refreshToken) {
    localStorage.setItem(CLAVE_REFRESH, tokens.refreshToken);
  }
  return tokens.token;
};

export const obtenerToken = () => localStorage.getItem(CLAVE_TOKEN);

export const obtenerRefreshToken = () => localStorage.getItem(CLAVE_REFRESH);

export const limpiarSesion = () => {
  localStorage.removeItem(CLAVE_TOKEN);
  localStorage.removeItem(CLAVE_REFRESH);
};
